import { Route } from 'react-router-dom';
import { AdminLoginScreen, SetPasswordScreen, ForgotPasswordScreen, ResetPasswordScreen } from '@/screens/admin';

export const authRoutes = [
  <Route key="admin-login" path="/admin/login" element={<AdminLoginScreen />} />,
  <Route key="admin-set-password" path="/admin/set-password" element={<SetPasswordScreen />} />,
  <Route key="admin-forgot-password" path="/admin/forgot-password" element={<ForgotPasswordScreen />} />,
  <Route key="admin-reset-password" path="/admin/reset-password" element={<ResetPasswordScreen />} />,
];

